import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Loading from '../../components/Loading/Loading';
import MeatballDropdown from '../../components/MeatballDropdown/MeatballDropdown';
import Page from '../../components/Page/Page';
import Title from '../../components/Title/Title';
import { permConst } from '../../constants/permConst';
import { platformCodes } from '../../constants/platformConstants';
import { subConst } from '../../constants/submissionsConstants';
import { getProduct } from '../../services/productsService';
import {
	getSubmissionActivityLog,
	getSubmissionAssets,
	getSubmissionDetails,
	getSubmissionTestResult,
} from '../../services/submissionsService';
import { getSubmissionFullVersion } from '../../utils/submissionUtils';
import { createMessageForError, toasterNotify } from '../../utils/toaster';
import { isAuthorized } from '../../utils/userUtils';
import ActivityLog from './utilComponents/ActivityLog';
import SubmissionSidebar from './utilComponents/SubmissionSidebar';

function mapStateToProps(state) {
	return {
		userProfile: state.authReducer.userProfile,
		sunsetFeatures: state.referenceReducer?.sunsetFeatures?.content,
	};
}

function parseFeature(features, inputKey) {
	if (features) {
		for (let feature of features) {
			if (feature.name === inputKey) {
				let returnValue = feature.values[0].value;
				if (typeof feature.values[0].value !== 'boolean') {
					returnValue =
						feature.values[0].value === 'YES' ||
						feature.values[0].value === 'Y';
				}
				return returnValue;
			}
		}
	}
}

export class SubmissionDetails extends Component {
	constructor(props) {
		super(props);
		this.productId = props.match.params.productId;
		this.submissionId = props.match.params.submissionId;

		this.state = {
			showModal: false,
			showAlertHeader: false,
			productInfo: null,
			submissionDetails: null,
			activityLog: null,
			productId: '',
			titleStatus: [],
			gameConfiguration: '',
			assets: null,
			testResult: null,
		};
		this.loadSubmissionTestResult = this.loadSubmissionTestResult.bind(this);
		this.loadActivityLog = this.loadActivityLog.bind(this);
		this.setProductSummary = this.setProductSummary.bind(this);
		this.setProductSubmissions = this.setProductSubmissions.bind(this);
		this.setSubmissionFiles = this.setSubmissionFiles.bind(this);
	}

	generateSubData(data) {
		let submission = data;
		if (submission) {
			submission['online_mp'] = parseFeature(
				submission.submission_features.features,
				'Online Multi Play',
			);
			submission['online_commerce'] = parseFeature(
				submission.submission_features.features,
				'Online Commerce',
			);
			submission['consumable_aoc'] = parseFeature(
				submission.submission_features.features,
				'Consumable AOC',
			);
			submission['ugc'] = parseFeature(submission.submission_features.features, 'UGC');
			submission['wifi'] = parseFeature(
				submission.submission_features.features,
				'Wifi Connect',
			);
			this.setState({
				submissionDetails: submission,
			});
		}
	}

	setProductSummary() {
		getProduct(this.productId)
			.then((response) => {
				this.setState({
					productInfo: response.data,
				});
			})
			.catch((error) => {
				toasterNotify(
					createMessageForError(error, 'retrieving submissions'),
					'error',
					error,
				);
				this.setState({
					productInfo: {},
				});
			});
	}

	setProductSubmissions() {
		getSubmissionDetails(this.submissionId)
			.then((response) => {
				this.generateSubData(response.data);
			})
			.catch((error) => {
				this.setState({
					submissionDetails: {},
				});
				toasterNotify(createMessageForError(error, 'loading submissions'), 'error', error);
			});
	}

	loadActivityLog() {
		getSubmissionActivityLog(this.submissionId)
			.then((response) => {
				this.setState({
					activityLog: response.data,
				});
			})
			.catch((error) => {
				this.setState({
					activityLog: [],
				});
				toasterNotify(createMessageForError(error, 'loading activity log'), 'error', error);
			});
	}

	setSubmissionFiles() {
		getSubmissionAssets(this.submissionId)
			.then((response) => {
				this.setState({
					assets: response.data,
				});
			})
			.catch((error) => {
				this.setState({
					assets: [],
				});
				toasterNotify(createMessageForError(error, 'loading assets'), 'error', error);
			});
	}

	loadSubmissionTestResult() {
		getSubmissionTestResult(this.submissionId)
			.then((response) => {
				this.setState({
					testResult: response.data,
				});
			})
			.catch((error) => {
				toasterNotify(createMessageForError(error, 'loading test results'), 'error', error);
			})
			.finally(() => {
				this.setState({
					testResult: '',
				});
			});
	}

	getPageTitle(productInfo) {
		if (!productInfo) {
			return '';
		}

		const version = this.getFullSubmissionVersion();
		return `${productInfo.game_name}${version && ` [${version}]`}`;
	}

	getFullSubmissionVersion() {
		const { submissionDetails } = this.state;

		return getSubmissionFullVersion(
			submissionDetails.product_release_version,
			submissionDetails.product_submission_version,
		);
	}

	componentDidMount() {
		this.setProductSubmissions();
		this.setProductSummary();
		this.loadSubmissionTestResult();
		this.loadActivityLog();
		this.setSubmissionFiles();
	}

	setTitleStatusState(status) {
		const titleStatus = {};
		titleStatus['class'] = this.getActivityStatusClassName(status);
		titleStatus['text'] = status;

		this.setState({
			titleStatus: titleStatus,
		});
	}

	getActivityStatusClassName(activityStatus) {
		const status = activityStatus.toUpperCase();
		if (status.includes(subConst.STATUS.APPROVED)) {
			return 'status-approved';
		}

		if (status.includes(subConst.STATUS.FAILED)) {
			return 'status-rejected';
		}

		return 'status-pending';
	}

	renderTitleButton() {
		const { productInfo } = this.state;
		const { userProfile } = this.props;

		const isSwitchProduct = productInfo.system_family === platformCodes['Nintendo Switch'];

		return !isSwitchProduct &&
			isAuthorized(userProfile.permissions, [permConst.SUBMISSION.EDIT.ALL]) ? (
				<>
					<MeatballDropdown id="submission-context-menu" toggleSize="lg">
						<MeatballDropdown.Item href={`/products/${this.productId}`}>
							View Product Details
						</MeatballDropdown.Item>
					</MeatballDropdown>
				</>
			) : null;
	}

	renderSideBar() {
		const { productInfo, submissionDetails, assets } = this.state;
		const { userProfile } = this.props;
		const isWUP = productInfo.system_family === platformCodes['Wii U'];

		return (
			<SubmissionSidebar
				submission={submissionDetails}
				submissionFiles={assets}
				productId={this.productId}
				submissionVersion={this.getFullSubmissionVersion()}
				productInfo={productInfo}
				userProfile={userProfile}
				isWUP={isWUP}
			/>
		);
	}

	decideTitleStatusClass(status) {
		let statusClass;
		switch (status) {
			case subConst.TYPE.LOTCHECK:
				statusClass = 'status-approved';
				break;
			case subConst.TYPE.PRECHECK:
				statusClass = 'status-info';
				break;
			case subConst.TYPE.FAILED:
				statusClass = 'status-danger';
				break;
			default:
				statusClass = 'status-info';
				break;
		}
		return statusClass;
	}
	render() {
		const { productInfo, showAlertHeader, submissionDetails, activityLog, assets, testResult } =
			this.state;
		const { userProfile } = this.props;
		const isLoading =
			productInfo == null ||
			submissionDetails == null ||
			activityLog == null ||
			assets == null ||
			testResult == null;

		const title = !isLoading && this.getPageTitle(productInfo);
		const titleStatus = {
			text: submissionDetails ? submissionDetails.status : '',
			class: submissionDetails ? this.decideTitleStatusClass(submissionDetails.status) : '',
		};

		if (
			!isAuthorized(userProfile.permissions, [
				permConst.PRODUCT.VIEW.ALL.FIRST,
				permConst.PRODUCT.VIEW.ALL.THIRD,
				permConst.PRODUCT.VIEW.COMPANY,
			])
		) {
			return <Redirect to="/" />;
		}
		return (
			<Page>
				{isLoading ? (
					<Loading />
				) : (
					<>
						{showAlertHeader && this.renderAlertHeader()}
						<Breadcrumb>
							<Breadcrumb.Item to="/products">Products</Breadcrumb.Item>
							<Breadcrumb.Item to={`/products/${this.productId}`}>
								{productInfo &&
									`${productInfo.game_name}${
										productInfo.game_code ? ` (${productInfo.game_code})` : ''
									}`}
							</Breadcrumb.Item>
							<Breadcrumb.Item active>{title}</Breadcrumb.Item>
						</Breadcrumb>
						<Title
							title={title}
							subtitle={productInfo.platform_name}
							status={titleStatus}
							button={this.renderTitleButton()}
						/>
						<Row className="mt-3">
							<Page.MainCol>
								<Page.ContentContainer>
									<ActivityLog
										productId={this.productId}
										submissionId={this.submissionId}
										loadActivityLog={this.loadActivityLog}
										activityLog={this.state.activityLog}
									/>
								</Page.ContentContainer>
							</Page.MainCol>
							<Page.SidebarCol>{this.renderSideBar()}</Page.SidebarCol>
						</Row>
					</>
				)}
			</Page>
		);
	}
}

export default connect(mapStateToProps)(SubmissionDetails);
